import type { ClassLevel } from './class';

// SCH-03: the three combinable cycles in V1 (Lycée explicitly excluded — product
// decision, too complex for now with its L/S/ES series).
export const CYCLES = ['PRESCOLAIRE', 'ELEMENTAIRE', 'COLLEGE'] as const;
export type Cycle = (typeof CYCLES)[number];

export function isCycle(value: string): value is Cycle {
  return (CYCLES as readonly string[]).includes(value);
}

/** Level -> cycle mapping, duplicated intentionally from apps/api/src/lib/cycles.ts
 * (apps/api and the front-end apps share no package between them — same pattern as
 * MIN_PASSWORD_LENGTH/the NINEA regex already duplicated elsewhere in this monorepo,
 * see CLAUDE.md). Used here for UX-only filtering (which levels to offer in a class
 * creation form, based on which cycles are activated) — the backend remains the
 * sole source of truth that actually rejects a class whose parent cycle isn't
 * activated. */
export const LEVEL_TO_CYCLE: Record<ClassLevel, Cycle> = {
  PS: 'PRESCOLAIRE',
  MS: 'PRESCOLAIRE',
  GS: 'PRESCOLAIRE',
  // SCH-13: CI (Cours d'Initiation) — first real level of the elementary cycle,
  // before CP.
  CI: 'ELEMENTAIRE',
  CP: 'ELEMENTAIRE',
  CE1: 'ELEMENTAIRE',
  CE2: 'ELEMENTAIRE',
  CM1: 'ELEMENTAIRE',
  CM2: 'ELEMENTAIRE',
  SIXIEME: 'COLLEGE',
  CINQUIEME: 'COLLEGE',
  QUATRIEME: 'COLLEGE',
  TROISIEME: 'COLLEGE',
};

export const CYCLE_LABELS: Record<Cycle, string> = {
  PRESCOLAIRE: 'Préscolaire',
  ELEMENTAIRE: 'Élémentaire',
  COLLEGE: 'Collège',
};
